import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLang } from '../context/LangContext';
import { API_URL } from '../config';

const API = API_URL;

const Hero = () => {
  const { t } = useLang();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/products/stats/public`)
      .then(r => setStats(r.data.data))
      .catch(() => {});
  }, []);

  return (
    <section className="hero-r">
      {/* Background */}
      <div className="hero-r__bg">
        <div className="hero-r__bg-left" />
        <div className="hero-r__bg-right" />
        <div className="hero-r__noise" />
        <div className="hero-r__line hero-r__line--1" />
        <div className="hero-r__line hero-r__line--2" />
        <div className="hero-r__line hero-r__line--3" />
      </div>

      {/* Inner */}
      <div className="hero-r__inner">

        {/* LEFT — texte */}
        <div className="hero-r__content">

          <div className="hero-r__tag">
            <span className="hero-r__tag-dot" />
            <span>{t('hero_badge')}</span>
          </div>

          <h1 className="hero-r__title">
            <span className="hero-r__title-white">Matrix</span>
            <span className="hero-r__title-red">Electronic</span>
            <span className="hero-r__title-outline">Devices</span>
          </h1>

          <p className="hero-r__by">BY <strong>Maher</strong></p>

          <p className="hero-r__sub">{t('hero_subtitle')}</p>

          <div className="hero-r__cta">
            <a href="#products" className="hero-r__btn-primary">
              {t('hero_cta_buy')}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </a>
            <a href="#products" className="hero-r__btn-ghost">{t('hero_cta_view')}</a>
          </div>

          <div className="hero-r__stats">
            <div className="hero-r__stat">
              <strong>{stats ? stats.total : '—'}</strong>
              <span>{t('hero_stat_products')}</span>
            </div>
            <div className="hero-r__sep" />
            <div className="hero-r__stat">
              <strong>{stats ? `${stats.totalStock}+` : '—'}</strong>
              <span>{t('hero_stat_clients')}</span>
            </div>
            <div className="hero-r__sep" />
            <div className="hero-r__stat">
              <strong>{stats ? `${stats.avgRating}★` : '—'}</strong>
              <span>{t('hero_stat_rating')}</span>
            </div>
          </div>
        </div>

        {/* RIGHT — visuel circuit */}
        <div className="hero-r__visual">
          <div className="hero-r__card hero-r__card--circuit">
            <div className="hero-r__card-glow" />
            <svg viewBox="0 0 400 400" className="hero-r__circuit" role="img" aria-label="Matrix Electronic Devices">
              <defs>
                <linearGradient id="heroTraceGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#ff2233" />
                  <stop offset="100%" stopColor="#cc0000" />
                </linearGradient>
              </defs>

              {/* traces inactives */}
              <g fill="none" stroke="#2a2a2e" strokeWidth="2">
                <path d="M200 40 V110 M200 290 V360 M40 200 H110 M290 200 H360" />
                <path d="M90 90 L140 90 L140 140 M310 90 L260 90 L260 140 M90 310 L140 310 L140 260 M310 310 L260 310 L260 260" />
                <path d="M60 150 H30 M60 250 H30 M340 150 H370 M340 250 H370" />
              </g>

              {/* traces actives */}
              <g fill="none" stroke="url(#heroTraceGrad)" strokeWidth="2.5" strokeLinecap="round">
                <path d="M200 110 V160" opacity="0.9" />
                <path d="M200 240 V290" opacity="0.9" />
                <path d="M110 200 H160" opacity="0.9" />
                <path d="M240 200 H290" opacity="0.9" />
                <path d="M140 140 L172 172" opacity="0.6" />
                <path d="M260 140 L228 172" opacity="0.6" />
                <path d="M140 260 L172 228" opacity="0.6" />
                <path d="M260 260 L228 228" opacity="0.6" />
              </g>

              {/* noeuds */}
              <g fill="#1a1a1e" stroke="#3a3a40" strokeWidth="1.5">
                <circle cx="200" cy="110" r="5" /><circle cx="200" cy="290" r="5" />
                <circle cx="110" cy="200" r="5" /><circle cx="290" cy="200" r="5" />
                <circle cx="140" cy="140" r="4" /><circle cx="260" cy="140" r="4" />
                <circle cx="140" cy="260" r="4" /><circle cx="260" cy="260" r="4" />
              </g>
              <g fill="#ff2233">
                <circle cx="200" cy="110" r="2.5" /><circle cx="200" cy="290" r="2.5" />
                <circle cx="110" cy="200" r="2.5" /><circle cx="290" cy="200" r="2.5" />
              </g>

              {/* coeur central */}
              <g transform="translate(200,200)">
                <rect x="-62" y="-62" width="124" height="124" rx="18" fill="#111114" stroke="#ff2233" strokeWidth="1.5" />
                <rect x="-62" y="-62" width="124" height="124" rx="18" fill="none" stroke="#ff2233" strokeWidth="1.5" opacity="0.4" transform="scale(1.18)" />
                <path d="M-30 28 V-28 L0 8 L30 -28 V28" fill="none" stroke="#ff2233" strokeWidth="6" strokeLinejoin="round" strokeLinecap="round" />
              </g>

              {/* coins de cadrage */}
              <g stroke="#ff2233" strokeWidth="2" fill="none" opacity="0.7">
                <path d="M20 20 H50 M20 20 V50" />
                <path d="M380 20 H350 M380 20 V50" />
                <path d="M20 380 H50 M20 380 V350" />
                <path d="M380 380 H350 M380 380 V350" />
              </g>
            </svg>
          </div>

          <div className="hero-r__float hero-r__float--top">
            <span className="hero-r__float-icon">📦</span>
            <div>
              <strong>{t('hero_shipping_label')}</strong>
              <small>{t('hero_shipping_sub')}</small>
            </div>
          </div>

          <div className="hero-r__float hero-r__float--bottom">
            <span className="hero-r__float-icon">⚡</span>
            <div>
              <strong>{t('hero_flash_label')}</strong>
              <small>{t('hero_flash_sub')}</small>
            </div>
          </div>

          {/* Cercles décoratifs */}
          <div className="hero-r__ring hero-r__ring--1" />
          <div className="hero-r__ring hero-r__ring--2" />
        </div>
      </div>

      {/* Scroll */}
      <div className="hero-r__scroll">
        <div className="hero-r__scroll-bar" />
        <span>Scroll</span>
      </div>
    </section>
  );
};

export default Hero;
